import React, { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import Loader from "@/components/Loader";

export default function Restauration() {
  const [items, setItems] = useState(null);
  const [locs, setLocs] = useState([]);
  const [popup, setPopup] = useState(null);

  useEffect(() => {
    api.get("/restauration").then(({ data }) => setItems(data)).catch(() => setItems([]));
    api.get("/restauration/locations").then(({ data }) => setLocs(data));
    api.get("/config/resto-popup").then(({ data }) => setPopup(data));
  }, []);

  const byLoc = useMemo(() => {
    if (!items) return {};
    const g = {};
    items.forEach((r) => {
      const locs = (r.locations && r.locations.length) ? r.locations : (r.location ? [r.location] : ["Autres"]);
      locs.forEach((l) => { (g[l] ||= []).push(r); });
    });
    return g;
  }, [items]);

  if (!items) return <Loader label="Chargement du menu…" />;

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-4xl font-black gradient-text inline-block">Restauration</h1>
      <p className="text-neutral-400 mt-2">Menus & boissons servis pendant le festival.</p>

      {popup && (
        <div className="card-hsg p-5 mt-6 border-l-4" style={{ borderLeftColor: "#FEC900" }}>
          <div className="font-bold text-lg">⚠️ {popup.title}</div>
          <div className="text-neutral-300 text-sm">{popup.subtitle}</div>
          <div className="text-neutral-400 text-sm mt-2">{popup.body}</div>
        </div>
      )}

      <div className="mt-8 space-y-8">
        {Object.entries(byLoc).map(([loc, list]) => {
          const meta = locs.find((l) => l.name === loc) || { colorHex: "#A1C861" };
          const color = meta.colorHex;
          return (
            <section key={loc}>
              <h2 className="text-xl font-black mb-3 flex items-center gap-3">
                <span className="chip" style={{ background: color + "22", color, border: `1px solid ${color}55` }}>🍽️ {loc}</span>
                <span className="text-neutral-500 text-sm font-medium">({list.length} article{list.length > 1 ? "s" : ""})</span>
              </h2>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {list.map((r) => (
                  <div key={r.id} className="card-hsg p-4 flex justify-between gap-3">
                    <div>
                      <div className="font-semibold">{r.title}</div>
                      {r.subtitle && <div className="text-neutral-400 text-sm">{r.subtitle}</div>}
                      <div className="flex gap-2 mt-2 text-xs">
                        {r.type && <span className="chip" style={{ background: "#ffffff10", color: "#ccc", border: "1px solid #ffffff22" }}>{r.type}</span>}
                        {r.age && <span className="chip" style={{ background: "#ffffff10", color: "#ccc", border: "1px solid #ffffff22" }}>{r.age}</span>}
                      </div>
                    </div>
                    <div className="font-black text-xl" style={{ color }}>CHF {Number(r.price_chf || 0).toFixed(0)}.-</div>
                  </div>
                ))}
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
}
